<ion-grid fixed>
  <ion-row>
    <ion-col size="12">
      <ion-item>
        <button style="background: transparent" (click)="incrementPage(-1)">
          <ion-icon
            style="font-size: 23px"
            name="arrow-back-circle-outline"
            slot="end"
            color="medium"
          ></ion-icon>
        </button>
        <button style="background: transparent" (click)="incrementPage(1)">
          <ion-icon
            name="arrow-forward-circle-outline"
            style="font-size: 23px"
            slot="end"
            color="medium"
          ></ion-icon>
        </button>
        <ion-label>Página</ion-label>
        <ion-input
          type="number"
          [(ngModel)]="page"
          pattern="-?[0-9]*(\.[0-9]+)?"
          style="width: 60px"
        ></ion-input>

        <ion-label *ngIf="pdf">de {{ pdf.numPages }}</ion-label>
        <button style="background: transparent" (click)="incrementZoom(-0.1)">
          <ion-icon
            style="font-size: 23px"
            name="remove-circle-outline"
            slot="end"
            color="medium"
          ></ion-icon>
        </button>
        <button style="background: transparent" (click)="incrementZoom(0.1)">
          <ion-icon
            name="add-circle-outline"
            style="font-size: 23px"
            slot="end"
            color="medium"
          ></ion-icon>
        </button>
      </ion-item>
    </ion-col>

    <ion-col size="12" *ngIf="recurso; else spinner">
      <h1 *ngIf="isLoaded; else spinner"></h1>

      <pdf-viewer
        [src]="recurso"
        [(page)]="page"
        [original-size]="originalSize"
        [fit-to-page]="fitToPage"
        (after-load-complete)="afterLoadComplete($event)"
        [zoom]="zoom"
        [show-all]="showAll"
        [stick-to-page]="stickToPage"
        [render-text]="renderText"
        [external-link-target]="'blank'"
        [autoresize]="autoresize"
        (on-progress)="onProgress($event)"
        (page-rendered)="pageRendered($event)"
      ></pdf-viewer>
    </ion-col>
    <ion-col size="12">
      <ion-button
        expand="block"
        shape="round"
        color="primary"
        (click)="downloadPdf(recurso)"
      >
        Descargar pdf
      </ion-button>
    </ion-col>
    <ng-template #spinner>
      <div class="spinner" style="height: 100%; width: 100%">
        <ion-row>
          <ion-col
            size="12"
            style="display: flex; justify-content: center; align-items: center"
          >
            <ion-spinner></ion-spinner>
          </ion-col>
        </ion-row>
      </div>
    </ng-template>
  </ion-row>
</ion-grid>
